import {
  TemplateType,
  typeTplinspectedKeysTemplate,
  inspectedTemplatesSchema,
} from "../Schemas/InspectionTemplatesSchemas";
import { generatePath } from "react-router-dom";
import { ENDPOINTS } from "../../../../modules/shared/webservices/constants/endpoints";
import { simpleRequest } from "core/services/api";
import { useQuery } from "react-query";

export const getTemplateMonitor = (region?: string) => {
  const path =
    region && region !== "ALL"
      ? generatePath(ENDPOINTS.TPL_INSPECTION, { region })
      : ENDPOINTS.TPL_INSPECTION_ALL_REGIONS;
  return simpleRequest(path, inspectedTemplatesSchema);
};

export function useInspectedTemplate(region?: string, fetch = true) {
  return useQuery(["templates", region], () => getTemplateMonitor(region), {
    enabled: !!region,
    select: (data: TemplateType): typeTplinspectedKeysTemplate[] => {
      return data?.map((template) => {
        let tpl = {
          id: template.id,
          name: template.name,
          sentinel_status: template.sentinel_status,
          total_messages: template.total_messages ?? 0,
        };

        if (!template.sentinel_data?.length) {
          return tpl;
        }

        const lastSentinelData =
          template.sentinel_data[template.sentinel_data.length - 1];

        return {
          ...tpl,
          ...lastSentinelData,
        };
      });
    },
  });
}
